import { Controller } from "@hotwired/stimulus"

// The truth is a set of hidden `exercise_ids[]` inputs in the `selection` target. It lives
// outside the `homework-picker-body` turbo-frame, so it survives lesson / course switches; the
// frame's checkboxes are unnamed and re-derived from that state on every frame load.
export default class extends Controller {
  static targets = ["selection", "total", "lessonsTotal", "submit", "exercise", "selectAll"]

  connect() {
    this.render()
  }

  // The body frame is swapped on every lesson / course switch; re-derive as soon as its
  // checkboxes appear rather than waiting for turbo:frame-load.
  exerciseTargetConnected() {
    if (this.renderQueued) return
    this.renderQueued = true
    queueMicrotask(() => {
      this.renderQueued = false
      this.render()
    })
  }

  toggle(event) {
    const box = event.currentTarget
    this.setSelected(box.value, box.dataset.lessonId, box.checked)
    this.render()
  }

  toggleLesson(event) {
    const checked = event.currentTarget.checked
    this.selectableBoxes().forEach((box) => {
      box.checked = checked
      this.setSelected(box.value, box.dataset.lessonId, checked)
    })
    this.render()
  }

  render() {
    const inputs = this.inputs()
    const ids = new Set(inputs.map((input) => input.value))

    this.selectableBoxes().forEach((box) => {
      box.checked = ids.has(box.value)
    })
    this.renderSelectAll()
    this.renderLessonCounts(inputs)

    const lessonIds = new Set(inputs.map((input) => input.dataset.lessonId))
    this.totalTarget.textContent = String(ids.size)
    this.lessonsTotalTarget.textContent = String(lessonIds.size)
    this.submitTarget.disabled = ids.size === 0
  }

  renderSelectAll() {
    if (!this.hasSelectAllTarget) return

    const boxes = this.selectableBoxes()
    const checkedCount = boxes.filter((box) => box.checked).length
    this.selectAllTarget.checked = boxes.length > 0 && checkedCount === boxes.length
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < boxes.length
  }

  renderLessonCounts(inputs) {
    this.element.querySelectorAll("[data-lesson-count]").forEach((pill) => {
      const count = inputs.filter((input) => input.dataset.lessonId === pill.dataset.lessonCount).length
      pill.textContent = String(count)
      pill.classList.toggle("hidden", count === 0)
    })
  }

  // Checkboxes of exercises already in the homework are disabled and never part of the state.
  selectableBoxes() {
    return this.exerciseTargets.filter((box) => !box.disabled)
  }

  inputs() {
    return Array.from(this.selectionTarget.querySelectorAll("input"))
  }

  setSelected(id, lessonId, selected) {
    const existing = this.inputs().find((input) => input.value === id)
    if (selected && !existing) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "exercise_ids[]"
      input.value = id
      input.dataset.lessonId = lessonId
      this.selectionTarget.appendChild(input)
    } else if (!selected && existing) {
      existing.remove()
    }
  }
}
